class FBO {
  constructor (scene, pixelRatio = 1, format = 'rgb', size = null) {
    this.scene = scene
    this.gl = scene.gl
    this.pixelRatio = pixelRatio
    this.format = format
    this.size = size

    if (size === null) {
      this.width = this.scene.width * this.pixelRatio
      this.heigth = this.scene.height * this.pixelRatio
    } else {
      this.width = size
      this.heigth = size
    }

    this.createTexture()
    this.createFB()

    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null)

    window.addEventListener('resize', this.onResize.bind(this))
    this.scene.passes.push(this)
  }

  createTexture () {
    this.targetTexture = this.gl.createTexture()

    let gl = this.gl

    gl.bindTexture(gl.TEXTURE_2D, this.targetTexture)

    let level = 0
    let internalFormat = gl.RGBA
    let border = 0
    let format = gl.RGBA
    let type = gl.UNSIGNED_BYTE
    if (this.format === 'float') {
      type = gl.FLOAT
    }
    let data = null

    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, this.width, this.heigth, border, format, type, data)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR)
  }

  onResize () {
    let gl = this.gl
    if (this.size === null) {
      this.width = this.scene.width * this.pixelRatio
      this.heigth = this.scene.height * this.pixelRatio
    } else {
      this.width = this.size
      this.heigth = this.size
    }
    gl.deleteTexture(this.targetTexture)
    gl.deleteFramebuffer(this.fb)
    this.createTexture()
    this.createFB()
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null)
  }

  createFB () {
    let gl = this.gl
    this.fb = gl.createFramebuffer()
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.fb)

    const level = 0
    const attachmentPoint = gl.COLOR_ATTACHMENT0
    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachmentPoint, gl.TEXTURE_2D, this.targetTexture, level)

    // create a depth renderbuffer
    const depthBuffer = gl.createRenderbuffer()
    gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer)

    // make a depth buffer and the same size as the targetTexture
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, this.width, this.heigth)
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBuffer)
  }

  preRender () {
    let gl = this.gl
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.fb)
    gl.viewport(0, 0, this.width, this.heigth)
    gl.clearColor(this.scene.clearColor[0], this.scene.clearColor[1], this.scene.clearColor[2], this.scene.clearColor[3])
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
  }

  postRender () {
    let gl = this.gl
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.scene.activeFrameBuffer)
  }

  bind () {
    let gl = this.gl
    gl.bindTexture(gl.TEXTURE_2D, this.targetTexture)
  }

  getTexture () {
    return this.targetTexture
  }
}

export default FBO
